import React, { useState } from 'react';
import '../../Styles/DownloadBeta.scss';
import { BarLoader} from 'react-spinners';
import { Link, useHistory } from 'react-router-dom';
import { downloadService } from '../../services/download.service';
import { useUser } from '../../contexts/userContext';
import { Helmet } from 'react-helmet';
import AlternativePaymentLayout from '../../components/Payment/AlternativePaymentLayout';
import Layout from '../../components/Layout';
import androidLogo from '../../assets/icons/android_logo.svg';
import windowsLogo from '../../assets/icons/windows_logo.svg';
import macTextLogo from '../../assets/icons/mac_text_logo.svg';
import arrowRight from '../../assets/icons/arrow_right.svg';
import iphoneTextLogo from '../../assets/icons/iphone_text_logo.svg';
import downloadIcon from '../../assets/icons/download_icon.svg';
import smallLogo from '../../assets/icons/logo_circle.svg';
import appStoreDownloadLogo from '../../assets/icons/App_Store.svg';
import altMacImage from '../../assets/images/altMacImage.png';
import iphoneImage from '../../assets/images/iphoneImage.png';
import backgroundGradient from '../../assets/images/truhu_bg_gradient.png';

const DownloadBeta = () => {
  const {
    state: { hasBetaAccess }
  } = useUser();
  const history = useHistory();
  const {
    state: { isLoggedIn }
  } = useUser();
  const [loading, setLoading] = useState(false);
  const betaVersions = [
    { no: 315, date: 'April 30, 2024' }
//    { no: 313, date: 'April 16, 2024' }
//      { no: 311, date: 'April 8, 2024' }
//     { no: 310, date: 'March 26, 2024' }
//     { no: 303, date: 'February 7, 2024' }
 //    { no: 296, date: 'January 23, 2024' }
 //     { no: 289, date: 'December 5, 2023' }
//    { no: 288, date: 'November 23, 2023' }
//    { no: 284, date: 'October 2, 2023' }
//    { no: 281, date: 'September 22, 2023' }
    //{ no: 275, date: 'September 9, 2023' }
    //{ no: 272, date: 'August 18, 2023' }
    //{ no: 266, date: 'June 23, 2023' }
    //{ no: 258, date: 'May 12, 2023' }
    // { no: 242, date: 'May 5, 2023' }
    // { no: 235, date: 'Apr 25, 2023' }
    // {no: 234, date: 'Apr 19, 2023'},
    // {no: 232, date: 'Apr 11, 2023'},
    // {no: 226, date: 'Mar 28, 2023'},
    // {no: 220, date: 'Mar 1, 2023'},
  ];
  // const alphaVersions = [
  //   {no: 206, date: 'Jan 10, 2023'},
  //   {no: 205, date: 'Jan 6, 2023'},
  //   {no: 204, date: 'Jan 5, 2023'},
  //   {no: 203, date: 'Jan 4, 2023'},
  //   {no: 202, date: 'Jan 3, 2023'},
  //   {no: 201, date: 'Dec 29, 2022'},
  // ]
  // const preAlphaVersions = [
  //   {no: 200, date: 'Dec 27, 2022'},
  //   {no: 198, date: 'Dec 23, 2022'},
  //   {no: 197, date: 'Dec 21, 2022'},
  // ]

  const latest = betaVersions.shift();
  const downloadDMG = async (title: string) => {
    setLoading(true);
    try {
      await downloadService.downloadBeta(title);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  // if (hasBetaAccess === null) {
  //   return null
  // }
  //
  // if (hasBetaAccess === false) {
  //   history.push('/');
  //   return null
  // }

  const redirectAppStore = `https://apps.apple.com/us/app/TRUHu/id${process.env.REACT_APP_APPLE_APP_ID}/`;

  return (
    <Layout>
      <Helmet>
          <title>Download the TruHu App - Monitor Color Calibration Tool | Good Color Made Easy</title>
          <meta
            name="description"
            content="Download the TruHu Monitor Color Calibration app on your preferred device and enter a world of optimized displays, color-perfect work, and happy clients!"
          />
      </Helmet>
      <AlternativePaymentLayout>
        <div className="alt__payment__form">
          <img className="alt__bg__gradient rotating" src={backgroundGradient} alt="bg_gradient" />
          <div className="alt__payment__list">
            <div className="alt__payment__image__container">
              <img src={altMacImage} alt="mac image"/>
            </div>
            <img src={macTextLogo} alt="mac text logo" />
            <div className="loader-wrap">
              {loading && (
                <>
                  Downloading... <BarLoader width={200} />
                </>
              )}
            </div>

            <div className="alt__payment__list__bottom">
              <button className="download__mac__button"
                onClick={() => downloadDMG(`TruHu+Desktop+${latest?.no}.dmg`)}>
                <img src={smallLogo} alt="logo"/>
                Download Desktop Mac
                <img src={downloadIcon} alt="download"/>
              </button>
              {betaVersions.map(({ no, date }) => (
                <div key={no} className="flex-sb">
                  <a className="colored-link" onClick={() => downloadDMG(`TruHu+Desktop+${no}.dmg`)}>
                    Download {no}
                  </a>
                  <div className="date">{date}</div>
                </div>
              ))}
              <Link to={'/wait-list'}>
                <div className="later__container">
                  <div className="later__top__row">
                    <img src={windowsLogo} alt="windows logo" />
                    <span>Windows</span>
                    <span> - &nbsp;&nbsp;Coming in 2024</span>
                    <img src={arrowRight} alt="arrow right" />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="alt__payment__form alt__payment__form__right">
          <img className="alt__bg__gradient rotating" src={backgroundGradient} alt="gradient background" />
          <div className="alt__payment__list">
            <div className="alt__payment__image__container">
              <img src={iphoneImage} alt="iphone image" />
            </div>
            <img src={iphoneTextLogo} alt="iphone text logo" />
            <div className="loader-wrap"></div>
            <div className="alt__payment__list__bottom">
              <a href={redirectAppStore} className="alt__app__store__link">
                <img src={appStoreDownloadLogo} alt="download on app store" />
              </a>
              <Link to={'/wait-list'}>
                <div className="later__container">
                  <div className="later__top__row">
                    <img src={androidLogo} alt="android logo" />
                    <span>Android</span>
                    <span> -  &nbsp;&nbsp;Coming in 2024</span>
                    <img src={arrowRight} alt="arrow right" />
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </AlternativePaymentLayout>
    </Layout>
  );
};

export default DownloadBeta;
